import jQuery from 'jquery';
let $ = jQuery;

import "./Widget.js";
    
/**
    * class HSN.Widget.PaymentList
    *
    * Encapsulates the common functionality of the PaymentList Widget.
    **/
HSN.Widget.PaymentList = function () {
    var application;
    var container;
    var paymentService;
    var deviceInformation;
    var showSelectButton;
    var showDefaultCardChecked;
    var showAddPaypal;
    var showMakeDefault;
    var eventIdentity;
    var addSelector = '.add-payment';
    var hasPaypalSelector = '.has-paypal';
    var editSelector = '.edit-item';
    var removeSelector = '.remove-payment';
    var selectSelector = '.select-payment';
    var makeDefaultSelector = '.make-payment-default';
    var paypalCardType = 'PY';
    var hasPaypalHtml = '<div><div id="paypal-edit-message-modal" class="module">' +
        '<div class="paypal-edit-header">To edit or remove PayPal</div>' +
        '<div>Manage or remove your PayPal Account Information at <a target="blank" href="https://www.paypal.com")">www.PayPal.com</a></div>' +
        '</div></div>';
    /**
        * new HSN.Widget.PaymentList.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.PaymentList]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        deviceInformation = application.DeviceInformation;
        showSelectButton = config.showSelectButton;
        showDefaultCardChecked = config.showDefaultCardChecked;
        showAddPaypal = config.showAddPaypal;
        showMakeDefault = config.showMakeDefault;
        eventIdentity = config.eventIdentity || '';
        paymentService = application._getPaymentService();
        bindEvents();
    }

    function bindEvents() {
        container.on('click', addSelector, HandleAdd);
        container.on('click', editSelector, HandleEdit);
        container.on('click', removeSelector, HandleRemove);
        container.on('change', selectSelector, HandleSelect);
        container.on('click', makeDefaultSelector, HandleMakeDefault);
        container.on('click', hasPaypalSelector, HandleHasPaypal);
    }
    function HandleAdd() {
        application.Events.Trigger(HSN.Widget.PaymentList.EVENT.ADD_SELECTED);
        return false;
    }
    function HandleEdit() {
        var identity = $(this).closest('.payment-method-container').data('payment-id');
        var cardType = $(this).closest('.payment-method-container').data('cardtype');
        if (cardType === paypalCardType) {
            HandleHasPaypal();
        }
        else {
            application.Events.Trigger(HSN.Widget.PaymentList.EVENT.EDIT_SELECTED, identity, this);
        }
        return false;
    }
    function HandleRemove() {
        var identity = $(this).closest('.payment-method-container').data('payment-id');
        var cardType = $(this).closest('.payment-method-container').data('cardtype');
        if (cardType === paypalCardType) {
            HandleHasPaypal();
        }
        else {
            HSN.SetWait();
            var numberOfCards = CountPaymentMethods();
            paymentService.RemovePaymentMethod({ paymentIdentity: identity }, {
                callback: function(data) {
                    if(data.success) {
                        Refresh();
                        application.Events.Trigger(HSN.Widget.PaymentList.EVENT.REMOVE_SUCCESS, identity, numberOfCards <= 1);
                    }
                    else {
                        HSN.CheckoutHandleError(container, data, 'Unfortunately there was an error attempting to remove your payment method, please try again.');
                    }
                },
                errorCallback: function() {
                    HSN.CheckoutHandleError(container, {}, 'Unfortunately there was an error attempting to remove your payment method, please try again.');
                },
                scope: this
            });
        }
        return false;
    }
    function HandleSelect() {
        if (!$(this).is(':checked')) {
            $(this).prop('checked', 'checked');
            $(this).val(true);
            return false;
        }
        $(selectSelector, container).each(function () {
            $(this).prop('checked', false);
        });
        $(this).prop('checked', 'checked');
        $(this).val(true);
        var identity = $(this).closest('.payment-method-container').data('payment-id');
        application.Events.Trigger(HSN.Widget.PaymentList.EVENT.SELECTED, identity, eventIdentity);
        return true;
    }
    function HandleMakeDefault() {
        var identity = $(this).closest('.payment-method-container').data('payment-id');
        HSN.SetWait();
        paymentService.SelectPayment({ paymentIdentity: identity }, {
            callback: function (data) {
                HSN.RemoveWait();
                if (data.success) {
                    Refresh();
                    application.Events.Trigger(HSN.Widget.PaymentList.EVENT.DEFAULT_CHANGED);
                } else {
                    alert('Unfortunately there was an error attempting to select your payment method, please try again.');
                }
            },
            errorCallback: function () {
                HSN.CheckoutHandleError(container, {}, 'Unfortunately there was an error attempting to select your payment method, please try again.');
            },
            scope: this
        });
        return false;
    }
    function HandleHasPaypal() {
        HSN.RemoveWait();
        var modalReference = application.GetPageIdModal();
        modalReference.Show(hasPaypalHtml, false);
        if (deviceInformation.IsMobile) {
            $('#paypal-edit-message-modal', modalReference.Content).addClass('mobile');
        }
        return false;
    }
    function Refresh() {
        HSN.SetWait();
        paymentService.GetPaymentList({ showSelect: showSelectButton, showMakeDefault: showMakeDefault, showDefaultCardChecked: showDefaultCardChecked, showAddPaypal: showAddPaypal, eventIdentity: eventIdentity }, {
            callback: function (data) {
                container.parent().html(data);
                if(deviceInformation.IsMobile) {
                    $('html,body').animate({
                        scrollTop: container.offset().top - HSN.GetMobileHeaderOffset()
                    }, 500);
                }
                application.Events.Trigger(HSN.Widget.PaymentList.EVENT.LIST_REFRESHED);
            },
            errorCallback: function () {
                HSN.CheckoutHandleError(container, {}, 'Unfortunately there was an error attempting to load the content, please try again.');
            },
            scope: this
        });
        HSN.RemoveWait();
    }
    function CountPaymentMethods() {
        return $('.payment-method-container', container).length;
    }
    function Destroy() {
        container.off('click', addSelector, HandleAdd);
        container.off('click', editSelector, HandleEdit);
        container.off('click', removeSelector, HandleRemove);
        container.off('change', selectSelector, HandleSelect);

        application = container = paymentService = null;
    }
    return {
        init: init,
        Refresh: Refresh,
        Destroy: Destroy
    }
};

HSN.Widget.PaymentList.EVENT = {
    ADD_SELECTED: 'HSN.Widget.PaymentList:ADD_SELECTED',
    EDIT_SELECTED: 'HSN.Widget.PaymentList:EDIT_SELECTED',
    SELECTED: 'HSN.Widget.PaymentList:SELECTED',
    REMOVE_SUCCESS: 'HSN.Widget.PaymentList:REMOVE_SUCCESS',
    LIST_REFRESHED: 'HSN.Widget.PaymentList:LIST_REFRESHED',
    DEFAULT_CHANGED: 'HSN.Widget.PaymentList:DEFAULT_CHANGED'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/PaymentList.js